/**
 * WebView 类型枚举。
 */
export enum WebViewTypeEnum {
  /**
   * WebKit Android
   */
  WebView = 'WebKit',
  /**
   * WKWebview iOS
   */
  WKWebview = 'WKWebview',
  /**
   * UIWebview iOS
   *
   * @deprecated 性能因素被抛弃
   */
  UIWebview = 'UIWebview',
  /**
   * Browser
   *
   * @description 浏览器
   *
   */
  Browser = 'Browser',
  /**
   * WeChatMPWebView
   */
  WeChatMPWebView = 'WxMiniProgramWebView',
  /**
   * Unsupported
   * @description 未支持的容器
   */
  Unsupported = 'Unsupported',
}
